<script>
  // make dynamic date to be added to footer
  let date = new Date().getFullYear();

  export let absolute = false;
</script>

<footer
  class="pb-6 {absolute ? 'absolute w-full bottom-0 bg-blueGray-800' : 'relative'}"
>
  <div class="container mx-auto px-4">
    <hr class="mb-6 border-b-1 border-blueGray-600" />
    <div class="flex flex-wrap items-center justify-between">
      <div class="flex items-center space-x-4">
        <div class="text-sm text-blueGray-500 font-semibold">
          Copyright © {date}
          <a
            href="https://seraphsystems.com"
            class="text-white hover:text-blueGray-300 text-sm font-semibold"
          >
            Seraph Systems
          </a>
        </div>
        <span class="text-sm text-blueGray-500">|</span>
        <div class="text-sm text-blueGray-500">
          Fotografía © <a href="https://andymorales.net/" target="_blank" rel="noopener noreferrer" class="inline-flex items-center align-middle">
            <img src="/img/andymorales.png" alt="Andy Morales" class="h-5 w-auto inline-block align-middle" />
          </a>
        </div>
      </div>
      <div>
        <ul class="flex flex-wrap list-none">
          <li>
            <a
              href="https://seraphsystems.com"
              class="text-white hover:text-blueGray-300 text-sm font-semibold block py-1 px-3"
            >
              Seraph Systems
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</footer>
